import React, { useState, useEffect } from 'react';
import { Box, useToast } from '@chakra-ui/react';
import PalmHeistProgressMap from './PalmHeistProgressMap';

/**
 * IslandMapGame Component
 * 
 * A standalone component for the Island Map game with RTP zones.
 */
const IslandMapGame = () => {
  const [userStats, setUserStats] = useState({
    totalWagered: 0,
    gamesPlayed: 0,
    winCount: 0,
    lossCount: 0,
    consecutiveDays: 1
  });
  const [balance, setBalance] = useState(1000); // Mock balance in SOL
  const toast = useToast();

  // Simulate player progress
  useEffect(() => {
    // This would normally come from your game state or blockchain
    const savedStats = localStorage.getItem('palmHeistPlayerStats');
    if (savedStats) {
      setUserStats(JSON.parse(savedStats));
    }
  }, []);

  // Handle claiming rewards
  const handleRewardClaim = (amount) => {
    setBalance(prev => prev + amount);
    toast({
      title: "Reward Claimed!",
      description: `${amount} SOL has been added to your balance!`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  // Handle playing a game
  const handlePlayGame = () => {
    // Simulate playing a game with current RTP
    const currentZone = Math.floor(userStats.totalWagered / 100) + 1;
    const zoneRtp = currentZone <= 3 ? 55 : (currentZone >= 10 ? 120 : 75 + (currentZone - 1) * 5); // RTP calculation based on zone
    const betAmount = 10; // Fixed bet amount for this example
    
    // Update stats
    const newStats = {
      ...userStats,
      totalWagered: userStats.totalWagered + betAmount,
      gamesPlayed: userStats.gamesPlayed + 1
    };
    
    // Determine win/loss based on RTP
    const isWin = Math.random() * 100 < zoneRtp;
    if (isWin) {
      const winAmount = betAmount * (zoneRtp / 100); // Win calculation based on RTP
      setBalance(prev => prev + winAmount);
      newStats.winCount = userStats.winCount + 1;
      
      toast({
        title: "You Won!",
        description: `Congratulations! You won ${winAmount.toFixed(2)} SOL with ${zoneRtp}% RTP!`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } else {
      setBalance(prev => prev - betAmount);
      newStats.lossCount = userStats.lossCount + 1;
      
      toast({
        title: "You Lost",
        description: `Better luck next time. You lost ${betAmount} SOL.`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    
    // Save updated stats
    setUserStats(newStats);
    localStorage.setItem('palmHeistPlayerStats', JSON.stringify(newStats));
  };

  return (
    <Box>
      <PalmHeistProgressMap 
        userStats={userStats}
        onPlayGame={handlePlayGame}
        balance={balance}
      />
    </Box>
  );
};

export default IslandMapGame;
